/* @jsx h */
import { defineComponent, h, ref, computed } from "vue";
import { useRouter, RouterLink, useRoute } from "vue-router";
import { useCustomer } from "@app/vue/providers/Auth";
import { LoyaltyQRModal } from "../LoyaltyQRModal";
import { useLocalization } from "@lemmonhq/uikit";

export const TopBar = defineComponent({
  name: "TopBar",
  setup() {
    const { customer, showAuthDialog } = useCustomer();
    const router = useRouter();
    const route = useRoute();
    const showLoyaltyModal = ref(false);
    const { t } = useLocalization();

    const isRegistered = computed(() => {
      if (!customer.value) return false;
      return "email" in customer.value && !customer.value.anon;
    });

    const displayName = computed(() => {
      if (!customer.value) return null;
      if (isRegistered.value && "name" in customer.value) {
        return customer.value.name;
      }
      if (isRegistered.value && "email" in customer.value) {
        return customer.value.email.split("@")[0];
      }
      return t("customer.account.guest");
    });

    const accountPath = computed(() => {
      const shopSlug = route.params.shopslug as string | undefined;
      return shopSlug
        ? `/restaurant/${shopSlug}/account/profile`
        : "/account/profile";
    });

    const handleLoyaltyClick = () => {
      showLoyaltyModal.value = true;
    };

    return () => (
      <>
        {/* Top Bar */}
        <div class="bg-black text-white h-8 flex items-center justify-between px-4 shadow-sm sticky top-0 z-[1] hidden">
          {/* Left Side - Loyalty QR */}
          <button
            onClick={handleLoyaltyClick}
            class="flex items-center gap-2 px-2 py-1.5 rounded-lg"
          >
            <span class="material-symbols-outlined text-yellow-400 text-xl">
              qr_code_2
            </span>
            <span class="text-xs font-medium hidden sm:inline">
              {customer.value
                ? t("customer.account.your_loyalty_pass")
                : t("customer.account.get_loyalty_pass")}
            </span>
            <span class="text-xs font-medium sm:hidden">
              {customer.value
                ? t("customer.account.your_loyalty_pass")
                : t("customer.account.get_loyalty_pass")}
            </span>
          </button>

          {/* Right Side - User Info */}
          <div class="flex items-center gap-3 hidden">
            {customer.value ? (
              <>
                {/* User Info */}
                <RouterLink
                  to={accountPath.value}
                  class="flex items-center gap-2 hover:bg-white/10 px-2 py-0 rounded-lg transition-colors"
                >
                  <div class="w-5 h-5 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center text-black font-bold text-xs">
                    {displayName.value?.charAt(0).toUpperCase()}
                  </div>
                  <span class="text-xs font-medium hidden md:inline truncate max-w-[120px]">
                    {displayName.value}
                  </span>
                </RouterLink>
              </>
            ) : (
              <button
                onClick={() => showAuthDialog()}
                class="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-lg transition-colors text-xs font-medium"
              >
                <span class="material-symbols-outlined text-base">login</span>
                <span class="hidden sm:inline">
                  {t("customer.account.sign_in")}
                </span>
              </button>
            )}
          </div>
        </div>

        {/* Loyalty Modal */}
        {showLoyaltyModal.value && customer.value && (
          <LoyaltyQRModal
            customer={customer.value}
            onClose={() => {
              showLoyaltyModal.value = false;
            }}
          />
        )}
      </>
    );
  },
});
